"use client";

import { useEffect, useState, useRef, Suspense } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { useUser } from "@/lib/context/user-context";
import { FullScreenLogin } from "@/components/ui/full-screen-login";

function LoginContent() {
  const { user } = useUser();
  const router = useRouter();
  const searchParams = useSearchParams();
  const [hasRedirected, setHasRedirected] = useState(false);
  const redirectExecuted = useRef(false);

  useEffect(() => {
    // 保存redirectTo参数到localStorage，这样登录后可以正确重定向
    const redirectTo = searchParams.get('redirectTo');
    console.log("LoginPage: redirectTo from URL params:", redirectTo);
    
    if (redirectTo && typeof window !== 'undefined') {
      console.log("LoginPage: Saving redirectTo to localStorage:", redirectTo);
      localStorage.setItem('auth_redirect_url', redirectTo);
    }
    
    // 也检查localStorage中现有的值
    if (typeof window !== 'undefined') {
      const existingRedirect = localStorage.getItem('auth_redirect_url');
      console.log("LoginPage: Existing redirect URL in localStorage:", existingRedirect);
    }
  }, [searchParams]);

  useEffect(() => {
    // 如果用户已登录且还没有重定向过，执行重定向
    if (user && !hasRedirected && !redirectExecuted.current) {
      redirectExecuted.current = true; // 立即设置标志，防止重复执行
      
      const redirectToFromParams = searchParams.get('redirectTo');
      const redirectToFromStorage = localStorage.getItem('auth_redirect_url');
      const finalRedirectTo = redirectToFromParams || redirectToFromStorage || '/';
      
      console.log("LoginPage: User is logged in, preparing redirect...");
      console.log("LoginPage: redirectTo from params:", redirectToFromParams);
      console.log("LoginPage: redirectTo from localStorage:", redirectToFromStorage);
      console.log("LoginPage: Final redirect URL:", finalRedirectTo);
      
      localStorage.removeItem('auth_redirect_url');
      console.log("LoginPage: Redirecting to:", finalRedirectTo);
      
      setHasRedirected(true);
      
      // 使用 replace 而不是 push，避免在浏览器历史中留下登录页面
      router.replace(finalRedirectTo);
    }
  }, [user, router, searchParams, hasRedirected]);

  // 如果用户已登录或已经重定向，不显示任何内容
  if (user || hasRedirected) {
    return null;
  }

  return <FullScreenLogin />;
}

export default function LoginPage() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <LoginContent />
    </Suspense>
  );
} 